<template>
	<div class="editting" v-if="show" style="margin:30px 0;">

		<!--新增工作经历模版容器-->
		<div class="Factory">

			<div class="row-24">

				<div class="row-12">
					<label class="label">公司名称</label>
					<input type="text" class="base-input-lg" maxlength="50" v-model="dataSource.company">
					<p class="error-tips" v-if="companyError">请输入公司名称</p>
				</div>

				<div class="row-12">
					<label class="label">所在行业</label>
					<industry-picker :maxcount='1' @finish-industry-pick='setIndustry' :text="industryText" v-model="industry"></industry-picker>
					<p class="error-tips" v-if="industryError">请至少选择一个行业</p>
				</div>
			</div>

			<div class="row-24-block">
				<label class="label">任职时间</label>

				<div class="time-range-block cf">

					<el-date-picker type="year" :clearable="false" value-format="yyyy" class="mini-input" prefix-icon="hidethisicon" v-model="dataSource.startYear"></el-date-picker>
					<span class="unit-span">年</span>

					<el-date-picker type="month" :clearable="false" format="MM" value-format="MM" :default-value="dataSource.startYear" class="mini-input" prefix-icon="hidethisicon" v-model='dataSource.startMonth'></el-date-picker>
					<span class="unit-span">月</span>

					<div class="split-line cf"></div>

					<el-date-picker type="year" :clearable="false" value-format="yyyy" class="mini-input" prefix-icon="hidethisicon" :disabled="dataSource.isNotYet" v-model='dataSource.endYear'></el-date-picker>
					<span class="unit-span">年</span>

					<el-date-picker type="month" :clearable="false" format="MM" value-format="MM" :default-value="dataSource.endYear" class="mini-input" prefix-icon="hidethisicon" :disabled="dataSource.isNotYet" v-model='dataSource.endMonth'></el-date-picker>
					<span class="unit-span">月</span>

					<div class="not-yet">
						<input type="checkbox" name="keepsecret" v-model='dataSource.isNotYet' @click="setEndTimeDisabled" />

						<div class="fake-checker">
							<img src="../../assets/img/common/icon-circle-hollow.png" v-if="!dataSource.isNotYet" />
							<img src="../../assets/img/common/icon-circle-tick.png" v-if="dataSource.isNotYet" />
						</div>
						<span>至今</span>
					</div>

				</div>
				<p class="error-tips" v-if="timeError" v-text="timeErrorTips"></p>
			</div>

			<div class="row-24">
				<div class="row-12">
					<label class="label">职位类别</label>
					<occupation-picker :maxcount='1' @finish-occupation-pick='setOccupation' :text="occupationText" v-model="occupation"></occupation-picker>
					<p class="error-tips" v-if="occupationError">请选择您的职位类别</p>
				</div>

				<div class="row-12">
					<label class="label">职位名称</label>
					<input type="text" class="base-input-lg" v-model="dataSource.jobTitle">
					<p class="error-tips" v-if="jobTitleError">请输入您的职位名称</p>
				</div>
			</div>

			<div class="row-24-block">
				<label class="label">工作内容</label>
				<textarea name="" class="base-textarea" placeholder="选填" v-model="dataSource.description"></textarea>
			</div>

		</div>

		<div class="row-24-block no-mb">
			<a href="javascript:;" class="btn-operation btn-save" @click="resumeWorkExperienceSave">保存</a>

			<a href="javascript:;" class="btn-operation btn-cancel" @click="resumeWorkExperienceAddCancel" v-if="type==='add'">取消</a>
			<a href="javascript:;" class="btn-operation btn-cancel" @click="resumeWorkExperienceEditCancel" v-if="type==='edit'">取消</a>
		</div>

	</div>
</template>

<script>
	import IndustryPicker from '@/components/Common/IndustryPicker.vue'
	import OccupationPicker from '@/components/Common/OccupationPicker.vue'
	//接口：1.保存新增工作经历 2.保存对现有项目的编辑
	import { httpResumeWorkExperienceAdd, httpResumeWorkExperienceEdit } from '@/api/resume'

	export default {
		name: 'ResumeWorkModal',
		components: {
			IndustryPicker,
			OccupationPicker,
		},
		props: {
			tempObj: {
				type: Object,
				required: true,
			},
			show: {
				type: Boolean,
				required: true,
			},
			resumeId: {
				required: true,
			},
			type: {
				required: true,
			}
		},
		data() {
			return {
				dataSource: {
					id: 0,
					company: '',
					industryId: '',
					startYear: '',
					startMonth: '',
					endYear: '',
					endMonth: '',
					isNotYet: false,
					occupationId: '',
					jobTitle: '',
					description: ""
				},
				companyError: false,
				//行业
				industry: [],
				industryText: '',
				industryError: false,
				//时间段
				timeError: false,
				timeErrorTips: '',
				//职业
				occupation: [],
				occupationText: '',
				occupationError: false,
				//
				jobTitleError: false,
			}
		},
		mounted() {
			this.setDataSouce();
		},
		methods: {
			//取消新增简历
			resumeWorkExperienceAddCancel() {
				this.setDataSouce();
				this.$emit('add-cancel');
			},

			//保存新增
			doAddWorkExperience(data) {
				httpResumeWorkExperienceAdd(data).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '新增成功',
							duration: 1200,
						})
						this.$emit('add-done');
						this.resetData();
					} else {
						console.log(r);
						this.$message.error('保存失败，请稍后再试。');
					}
				}).catch(err => {
					console.log(err);
					this.$message.error('保存失败，请稍后再试。');
				})
			},

			//保存编辑
			doEditWorkExperience(data) {
				httpResumeWorkExperienceEdit(data).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '修改成功',
							duration: 1200,
						})
						this.$emit('edit-done'); //告诉父组件我编辑完了
						//this.resetData();
					} else {
						console.log(r);
						this.$message.error('保存编辑失败，请您稍后再试！');
					}

				}).catch(err => {
					console.log(err);
					this.$message.error('保存编辑失败，请您稍后再试！');
				});
			},

			resetData() {
				this.resetPicker();
				const tempObj = {
					id: 0,
					company: '',
					industryId: '',
					industryInfo: {},
					startYear: '',
					startMonth: '',
					endYear: '',
					endMonth: '',
					isNotYet: false,
					occupationId: '',
					occupationInfo: {},
					jobTitle: '',
					description: ""
				};
				this.dataSource = JSON.parse(JSON.stringify(tempObj));
			},

			//取消编辑
			resumeWorkExperienceEditCancel() {
				this.setDataSouce();
				this.$emit('edit-cancel');
			},

			//保存新增工作经历
			resumeWorkExperienceSave() {
				const oData = this.buildData(); //发送的数据对象
				const canISubmit = this.checkSubmitData();
				if(!canISubmit) return;
				this.type === 'add' ? this.doAddWorkExperience(oData) : this.doEditWorkExperience(oData);
			},

			//组装请求所需要的数据
			buildData() {
				let dateTo;
				let cur_date;
				let d = new Date();
				let year = d.getFullYear();
				let month = d.getMonth() + 1;
				dateTo = year + "-" + month;
				cur_date = year + "-" + month;

				if(this.dataSource.isNotYet) {
					this.dataSource.endYear = year.toString();
					this.dataSource.endMonth = month.toString();
				}

				let oData = {
					resumeId: this.resumeId,
					id: this.dataSource.id || 0,
					company: this.dataSource.company,
					industry: this.dataSource.industryId,
					occupationId: this.dataSource.occupationId,
					jobTitle: this.dataSource.jobTitle,
					dateFrom: this.dataSource.startYear.toString() + "-" + this.dataSource.startMonth.toString(),
					dateTo: this.dataSource.isNotYet ? cur_date : (this.dataSource.endYear + "-" + this.dataSource.endMonth),
					isCurrent: this.dataSource.isNotYet,
					description: this.dataSource.description,
				};
				return oData;
			},

			//提交数据时验证
			checkSubmitData() {
				if(!this.dataSource.company) {
					this.companyError = true;
					return false;
				} else {
					this.companyError = false;
				}

				if(!this.dataSource.industryId) {
					this.industryError = true;
					return false;
				} else {
					this.industryError = false;
				}

				if((!this.dataSource.endYear || !this.dataSource.endMonth) && !this.dataSource.isNotYet) {
					this.timeError = true;
					this.timeErrorTips = '请完善项目时间'
					return false;
				} else {
					this.timeError = false;
				}

				if(this.dataSource.endYear && !this.dataSource.isNotYet) {
					if(this.dataSource.endYear < this.dataSource.startYear) {
						this.timeError = true;
						this.timeErrorTips = '项目截至时间必须大于起始时间'
						return false;
					} else {
						this.timeError = false;
					}
				}

				if(!this.dataSource.occupationId) {
					this.occupationError = true;
					return false;
				} else {
					this.occupationError = false;
				}

				if(!this.dataSource.jobTitle) {
					this.jobTitleError = true;
					return false;
				} else {
					this.jobTitleError = false;
				}

				return true;
			},

			//完成行业选择
			setIndustry(result) {
				this.industry = result||[];
				this.dataSource.industryId = this.industry.length>0?result[0].id:'';
				this.buildIndustryText();
			},

			//拼接出期望行业文本
			buildIndustryText() {
				let temp_str = '';
				this.industry.forEach(item => {
					temp_str += item.name + '，';
				});
				let len = temp_str.length - 1;
				this.industryText = temp_str.substr(0, Number(len));
			},

			//完成职业选择
			setOccupation(result) {
				this.occupation = result||[];
				this.dataSource.occupationId = this.occupation.length>0?result[0].id:'';
				this.buildOccupationText();
			},

			//拼接出期望职业文本
			buildOccupationText() {
				let temp_str = '';
				this.occupation.forEach(item => {
					temp_str += item.name + '，';
				});
				let len = temp_str.length - 1;
				this.occupationText = temp_str.substr(0, Number(len));
			},

			//编辑项目时选择至今
			setEndTimeDisabled() {
				if(this.dataSource.isNotYet) {
					this.dataSource.isNotYet = false;
				} else {
					this.dataSource.isNotYet = true;
					let d = new Date();
					let year = d.getFullYear();
					let month = d.getMonth() + 1;
					this.dataSource.endYear = year.toString();
					this.dataSource.endMonth = month.toString();
				}
			},

			//根据传入的类型设置好本实例的数据
			setDataSouce() {
				if(this.type === 'add') {

					this.resetPicker();
					const tempObj = {
						id: 0,
						company: '',
						industryId: '',
						industryInfo: {},
						startYear: '',
						startMonth: '',
						endYear: '',
						endMonth: '',
						isNotYet: false,
						occupationId: '',
						occupationInfo: {},
						jobTitle: '',
						description: ""
					};
					this.dataSource = JSON.parse(JSON.stringify(tempObj));
				} else {
					let raw_data = JSON.parse(JSON.stringify(this.tempObj)); //编辑时传递过来的数据需要处理
					this.dataSource.id = raw_data.id;
					this.dataSource.company = raw_data.company;
					this.dataSource.industryId = raw_data.industryId;
					this.dataSource.startYear = raw_data.dateFromStr.split(".")[0];
					this.dataSource.startMonth = raw_data.dateFromStr.split(".")[1];
					this.dataSource.endYear = raw_data.dateToStr.split(".")[0];
					this.dataSource.endMonth = raw_data.dateToStr.split(".")[1];
					this.dataSource.isNotYet = raw_data.isCurrent;
					this.dataSource.occupationId = raw_data.occupationId;
					this.dataSource.jobTitle = raw_data.jobTitle;
					this.dataSource.description = raw_data.description.toString().replace(/<br>/g, '\n');
					this.industry = [raw_data.industryInfo];
					this.industryText = raw_data.industryInfo.name;
					this.occupation = [raw_data.occupationInfo];
					this.occupationText = raw_data.occupationInfo.name;
				}
			},
			//重置Picker状态
			resetPicker() {
				this.industry = [];
				this.industryText = '';
				this.occupation = [];
				this.occupationText = '';
			}
		}
	}
</script>

<style scoped lang='less'>
	@import url("../../assets/css/editResume.less");
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeWorkModal.vue